import type { PaletteBadge } from "@/components/commandPalette/paletteIcons";
export interface PaletteWorker {
  id: string;
  name: string;
  model: string;
  enabled: boolean;
  businessId?: string;
  folderId?: string | null;
  description?: string | null;
}

export type PaletteItemType = "navigation" | "worker" | "action";

export interface PaletteItem {
  id: string;
  type: PaletteItemType;
  title: string;
  subtitle?: string;
  keywords?: string[];
  badge?: {
    text: string;
    variant: PaletteBadge;
  };
  perform: () => void | Promise<void>;
}

export interface PaletteGroup {
  id: string;
  label: string;
  items: PaletteItem[];
}

export function filterPaletteGroups(
  groups: PaletteGroup[],
  query: string
): PaletteGroup[] {
  const q = query.trim().toLowerCase();
  if (!q) {
    return groups.filter((g) => g.items.length > 0);
  }

  const terms = q.split(/\s+/).filter(Boolean);

  return groups
    .map((group) => {
      const items = group.items.filter((item) => {
        const searchable = [
          item.title,
          item.subtitle ?? "",
          ...(item.keywords ?? []),
          item.badge?.text ?? "",
        ]
          .join(" ")
          .toLowerCase();

        return terms.every((term) => searchable.includes(term));
      });

      return {
        ...group,
        items,
      };
    })
    .filter((group) => group.items.length > 0);
}

export function flattenGroupItems(groups: PaletteGroup[]): PaletteItem[] {
  return groups.flatMap((g) => g.items);
}

export function computeNextIndex(
  currentIndex: number,
  totalItems: number,
  direction: "up" | "down"
): number {
  if (totalItems <= 0) return 0;
  if (direction === "down") {
    return (currentIndex + 1) % totalItems;
  }
  return (currentIndex - 1 + totalItems) % totalItems;
}
